<template>
    <div class="md-layout" v-if="screenVisible">
        <!-------- PAGE -------->
        <!-- PRODUCT -->
        <product-header
            :productLoading="productLoading"
            :product="product"
        ></product-header>
        <!-- FILTER -->
        <param-filter
            :baseStore="baseStore"
            parameterTypeTitle="loja"
        ></param-filter>
        <!-- TABLE -->
        <param-table
            :baseStore="baseStore"
            parameterType="branch-parameter"
            parameterTypeTitle="loja"
            :parameters="branchparameters"
            :editModalOpen="editModalOpen"
            :actionModalOpen="actionModalOpen"
            :similarProductModalOpen="similarProductModalOpen"
        ></param-table>

        <!-------- MODALS -------->
        <!-- EDIT -->
        <edit-modal
            ref="editModal"
            :baseStore="baseStore"
            parameterType="branch-parameter"
            :productId="this.productId"
        ></edit-modal>
        <!-- ACTIONS -->
        <actions-modal
            ref="actionsModal"
            :baseStore="baseStore"
            parameterType="branch-parameter"
            :parameters="branchparameters.results"
        ></actions-modal>
        <!-- SIMILAR PRODUCT -->
        <similar-product-modal
            ref="similarProductModal"
            :baseStore="baseStore"
        ></similar-product-modal>
    </div>
    <div v-else>
        <div v-if="me">
            Você não pode acessar essa página!
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Utils from '@/utils'

import ProductHeader from '@/components/Parameters/ProductHeader'
import ParamFilter from '@/components/Parameters/Filter'
import ParamTable from '@/components/Parameters/ParamTable'
import ActionsModal from '@/components/Parameters/Modals/ActionsModal'
import EditModal from '@/components/Parameters/Modals/EditModal'
import SimilarProductModal from '@/components/Parameters/Modals/SimilarProductModal'

import Swal from 'sweetalert2'

const model = 'branchparameter'

export default {
    async created() {
        this.readProduct(this.productId)
        this.readBranchParameter({
            product_id: this.productId
        })
    },
    mounted() {
        this.editModalOpen = this.$refs.editModal.editModalOpen
        this.actionModalOpen = this.$refs.actionsModal.actionModalOpen
        this.similarProductModalOpen = this.$refs.similarProductModal.similarProductModalOpen
    },
    props: ['productId'],
    components: {
        ProductHeader,
        ParamTable,
        ActionsModal,
        EditModal,
        SimilarProductModal,
        ParamFilter
    },
    computed: {
        ...mapState({
            branchparameters: state => state[model].page,
            product: state => state['products'].current,
            me: state => state['auth'].me
        }),

        screenVisible() {
            if (this.me)
                return (
                    this.me.permissions.indexOf(
                        'branches.view_branchparameter'
                    ) > -1
                )
            return false
        }
    },
    data() {
        return {
            baseStore: model,
            selectedBranches: [],
            productLoading: true,
            removeLoading: false,

            dd: [
                {
                    id: 5
                }
            ],
            /**
                Padrao: status ativo e tipo padrao
                Modificado: status ativo e tipo modificado
                Removido: status removido e tipo *
                Removido Manualmente: status removido manualmente e tipo *
             */

            // method references
            editModalOpen: null,
            actionModalOpen: null,
            similarProductModalOpen: null
        }
    },
    methods: {
        ...mapActions(model, {
            readBranchParameter: 'read',
            updateBranchParameters: 'update',
            removeBranchParameters: 'remove'
        }),
        ...mapActions('products', {
            _readProduct: 'readById'
        }),

        formatNumber: (number, type) => Utils.formatNumber(number, type),

        async readProduct(productId) {
            this.productLoading = true
            await this._readProduct(productId)
            this.productLoading = false
        }
    }
}
</script>

<style lang="scss" scoped>
.image-content {
    text-align: center;
    min-width: 200px;
}

.md-icon-button {
    width: 4rem;
}

.list-content {
    .item-content {
        float: right;
    }
}
.edit-mode-right-panel {
    text-align: right;
}
.removed {
    color: rgb(97, 0, 0);
}
.btn-panel {
    font-size: 1.5em;
    cursor: pointer;
}

.md-toolbar {
    background-color: #12578f !important;
    position: fixed !important;
    top: 50px;
    left: 280px;
    right: 20px;
    width: auto;
}
.sidebar-mini .md-toolbar {
    margin-left: 20px;
    right: 20px;
    left: 80px;
}

.cell-highlight {
    background: #f5dddd;
}
</style>
